<template>
    <div class="form-item">
        <label class="label-caption">Tipo Pagamento OS</label>
        <select :value="tipoSelecionado" @change="atualizarTipo" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        tipoSelecionado: {type: Number, default: null}
    },

    data() {
        return{
            lsTipos:[
                // {id: 0, descricao: 'TODOS'},
                {id: 1, descricao: 'PRÉ-PAGO'},
                {id: 2, descricao: 'PÓS-PAGO'},
                {id: 9, descricao: 'OPCIONAL'}
            ]
        };
    },

    methods: {
        atualizarTipo(event) {
            this.$emit('update:tipoSelecionado', Number(event.target.value));
        }
    }
};
</script>